// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pSQHT5HMSwgeXHwcmdAI {
    display: none;
}

.ecrooNjBRfYH0TzorF2T {
    width: 265x;
}

.tKygQ4LMDikHs5Hsh0Qk {
    position: fixed;
    height: 100vh;
    width: 265px;
    max-height: 100vh;
    min-width: 265px;
    align-self: stretch;

    box-sizing: border-box;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

    display: flex;
    flex-direction: column;
}

.fUnS8BXXQeLUzup7jb9J {
    font-family: Fjalla One, "Gill Sans Ultra Bold Condensed", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    margin-top: 0;
    padding: 24px 24px 0 24px;
}

.VT7vrIbFRCSjs6mrLoSQ {
    height: 48px;
    padding: 0 24px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
}

.VT7vrIbFRCSjs6mrLoSQ span {
    display: flex;
    align-items: center;
    color: black;
}

.VT7vrIbFRCSjs6mrLoSQ .JEy1mpMxOmIACcQpl6Td {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
}

.VMEEL2Y2r_Mr0hzwjSgA .JEy1mpMxOmIACcQpl6Td, .VMEEL2Y2r_Mr0hzwjSgA span {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.VT7vrIbFRCSjs6mrLoSQ .JEy1mpMxOmIACcQpl6Td {
    margin-right: 8px;
}

.VMEEL2Y2r_Mr0hzwjSgA {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    background-color: #F4F6FE;
    font-weight: 500;
}

.VT7vrIbFRCSjs6mrLoSQ::before {
    font-weight: 500;
    height: 0;
}

.W920fojHyS7FQ0kjD32u {
    opacity: 0;
}

.VMEEL2Y2r_Mr0hzwjSgA .W920fojHyS7FQ0kjD32u {
    opacity: 1;
}

.zx30ypfJQoADLZJfiykx {
    z-index: 1000;
    bottom: 48px;
    position: absolute;
    background-color: white;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    border-radius: 72px;
    width: 72px;
    height: 72px;
    padding: 4px;
    box-shadow: 6px 0 6px 0 rgb(0 0 0 / 10%);
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.yC5D3ODfROlNJxageMMi {
    left: 229px;
}

.yaxtXlsdTrY8GH0zf60r {
    left: -36px;
}

.zx30ypfJQoADLZJfiykx {
    display: none;
}

.lTEYbaUKbX20_ZN_RzqU {
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 150%;
    justify-content: left;
    margin-top: auto;
    margin-bottom: 2rem;
}

@media screen and (max-width: 768px) {
    .zx30ypfJQoADLZJfiykx { display: flex; }

    .g8MpYnQVf_uFwakj0vw9 {
        background-color: white;
        z-index: 900;
        position: fixed;
        min-height: 100vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;;IAEnB,sBAAsB;IACtB,uCAAuC;;IAEvC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qEAAqE;IACrE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;;IAEf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mDAAiB;AACrB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mDAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mDAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAU,aAAa,EAAE;;IAEzB;QACI,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["@value colors: \"../library/style/colors.css\";\n@value color-purple, color-gray from colors;\n\n.hide {\n    display: none;\n}\n\n.sidebar {\n    width: 265x;\n}\n\n.navigation {\n    position: fixed;\n    height: 100vh;\n    width: 265px;\n    max-height: 100vh;\n    min-width: 265px;\n    align-self: stretch;\n\n    box-sizing: border-box;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n\n    display: flex;\n    flex-direction: column;\n}\n\n.logo {\n    font-family: Fjalla One, \"Gill Sans Ultra Bold Condensed\", sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 24px;\n    margin-top: 0;\n    padding: 24px 24px 0 24px;\n}\n\n.link {\n    height: 48px;\n    padding: 0 24px;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    text-decoration: none;\n}\n\n.link span {\n    display: flex;\n    align-items: center;\n    color: black;\n}\n\n.link .icon {\n    color: color-gray;\n}\n\n.active .icon, .active span {\n    color: color-purple;\n}\n\n.link .icon {\n    margin-right: 8px;\n}\n\n.active {\n    color: color-purple;\n    background-color: #F4F6FE;\n    font-weight: 500;\n}\n\n.link::before {\n    font-weight: 500;\n    height: 0;\n}\n\n.arrow {\n    opacity: 0;\n}\n\n.active .arrow {\n    opacity: 1;\n}\n\n.button {\n    z-index: 1000;\n    bottom: 48px;\n    position: absolute;\n    background-color: white;\n    color: color-purple;\n    border-radius: 72px;\n    width: 72px;\n    height: 72px;\n    padding: 4px;\n    box-shadow: 6px 0 6px 0 rgb(0 0 0 / 10%);\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.open {\n    left: 229px;\n}\n\n.close {\n    left: -36px;\n}\n\n.button {\n    display: none;\n}\n\n.logout {\n    font-weight: 400;\n    font-family: 'Roboto', sans-serif;\n    font-size: 16px;\n    line-height: 150%;\n    justify-content: left;\n    margin-top: auto;\n    margin-bottom: 2rem;\n}\n\n@media screen and (max-width: 768px) {\n    .button { display: flex; }\n\n    .mobile {\n        background-color: white;\n        z-index: 900;\n        position: fixed;\n        min-height: 100vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"hide": `pSQHT5HMSwgeXHwcmdAI`,
	"sidebar": `ecrooNjBRfYH0TzorF2T`,
	"navigation": `tKygQ4LMDikHs5Hsh0Qk`,
	"logo": `fUnS8BXXQeLUzup7jb9J`,
	"link": `VT7vrIbFRCSjs6mrLoSQ`,
	"icon": `JEy1mpMxOmIACcQpl6Td`,
	"active": `VMEEL2Y2r_Mr0hzwjSgA`,
	"arrow": `W920fojHyS7FQ0kjD32u`,
	"button": `zx30ypfJQoADLZJfiykx`,
	"open": `yC5D3ODfROlNJxageMMi`,
	"close": `yaxtXlsdTrY8GH0zf60r`,
	"logout": `lTEYbaUKbX20_ZN_RzqU`,
	"mobile": `g8MpYnQVf_uFwakj0vw9`
};
export default ___CSS_LOADER_EXPORT___;
